module.exports = __webpack_public_path__ + "static/media/m_sf_17.211311e8.png";